import { useQuery } from '@tanstack/react-query';
import * as payloadsApi from '@/services/payloadsApi';

export function usePayloadList() {
  return useQuery({
    queryKey: ['payloads'],
    queryFn: async () => {
      const result = await payloadsApi.listPayloads();
      console.log('[usePayloadList] raw result:', result);
      // Handle case where result might be the envelope itself
      if (result && typeof result === 'object' && 'data' in result && Array.isArray((result as any).data)) {
        return (result as any).data;
      }
      return Array.isArray(result) ? result : [];
    },
  });
}

export function usePayloadSchema(kind: string, identifier: string, enabled = true) {
  return useQuery({
    queryKey: ['payloadSchema', kind, identifier],
    queryFn: () => payloadsApi.getPayloadSchema(kind, identifier),
    enabled: enabled && !!kind && !!identifier,
  });
}
